import { Alert, Button } from '@mui/material'
import { usePageNavigation } from 'hooks/useNavigation'
import React, { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Spinner from 'components/Spinner/Spinner'
import { useCreateSubscriptionMutation } from 'graphql/generated/graphql'

export default function SubscriptionCallback(): JSX.Element {
  const [searchParams] = useSearchParams()
  const success = searchParams.get('success')
  const sessionId = searchParams.get('session_id')
  const { navigateToDashboard } = usePageNavigation()
  const [isLoading, setIsLoading] = useState(false)
  const firstRender = useRef(true)
  const [createSubscription] = useCreateSubscriptionMutation()

  useEffect(() => {
    if (firstRender.current && success === 'true') {
      setIsLoading(true)
      firstRender.current = false
      try {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetch('/payment-portal-session', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            session_id: sessionId,
          }),
        })
          .then(async (response) => await response.json())
          .then(async (result) => {
            await createSubscription({
              variables: {
                planId: result?.planId,
                productId: result?.productId,
                productName: result?.productName,
                session_id: result?.session_id,
                subscriptionId: result?.subscriptionId,
                endDate: result?.subscriptionEndDate.toString(),
                customer_id: result?.customerId,
              },
            })
            setIsLoading(false)
          })
      } catch (e) {
        console.log(e)
        setIsLoading(false)
      }
    }
  }, [])

  if (isLoading) {
    return (
      <div>
        <div
          style={{
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <div
      style={{
        // padding: '0 5vw',
        display: 'flex',
        flexFlow: 'column',
        height: '100%',
      }}
    >
      <div style={{ flex: '1 1 auto' }}>
        <h2>Nalapod Plus Plan</h2>
        <div>
          {success === 'true' ? (
            <Alert severity="success">
              Thank you for subscribing! 🎉 Your subscription is now active and
              ready to use.
            </Alert>
          ) : (
            <Alert severity="error">
              Your payment was canceled, or if an error occurred, no charges
              were made; you can double-check your payment details, or return
              anytime to subscribe, and our support team is here to assist you
              with any questions.
            </Alert>
          )}
        </div>
      </div>
      <Button
        variant="contained"
        onClick={navigateToDashboard}
        sx={{
          maxWidth: '190px',
          display: 'flex',
          justifyContent: 'space-between',
          justifySelf: 'flex-end',
          flex: '0 1 40px',
          //   alignSelf: 'flex-end',
        }}
      >
        <ArrowBackIcon />
        Back to Nalapod
      </Button>
    </div>
  )
}
